import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import batchActions from '../../../../../actions/batch.actions';
import lookupActions from '../../../../../actions/lookup.actions';
import helper from '../../../../../utils/helper';
import qs from 'qs';
import Loading from '../../../../Helpers/Loading';
import Backend from '../../../../Layouts/Backend';
import NewBatchReportPage from './NewBatchReportPage';

class NewBatchReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      departments: [],
      users: [],
      groups: [],
      isSubmitting: false,
      loading: false,
    };
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    let state = {};
    if (nextProps.lookup.departments !== prevState.departments) {
      state.departments = nextProps.lookup.departments;
    }
    if (nextProps.lookup.users !== prevState.users) {
      state.users = nextProps.lookup.users;
    }
    if (nextProps.lookup.groups !== prevState.groups) {
      state.groups = nextProps.lookup.groups;
    }
    if (nextProps.batch.batchReports !== prevState.batchReports) {
      state.batchReports = nextProps.batch.batchReports;
    }
    if (nextProps.batch.processes !== prevState.processes) {
      state.processes = nextProps.batch.processes;
    }
    if (nextProps.batch.loading !== prevState.loading) {
      state.loading = nextProps.batch.loading;
    }
    state.errors = helper.centralizeError([
      nextProps.lookup.errors,
      nextProps.batch.errors,
    ]);
    return Object.keys(state).length ? state : null;
  }
  componentDidMount() {
    const { deptId } = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    });
    this.setState({ loading: true }, async () => {
      await this.props.lookupActions.getDepartments();
      await this.props.lookupActions.getUsers();
      await this.props.lookupActions.getBRGroupsByDeptId(deptId);
      this.setState({ loading: false });
    });
  }
  onCreateBatch = async (values) => {
    const { deptId } = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    });
    const _values = Object.assign({}, values);
    _values.containsNames = false;
    this.setState({ isSubmitting: true }, async () => {
      await this.props.batchActions
        .createBatchReport({ ..._values, deptId })
        // .then((resp) => {
        //   if (values.processes.length) {
        //     values.processes.forEach(async (_process) => {
        //       await this.props.batchActions.createProcess({
        //         ..._process,
        //         batchReportId: resp.id,
        //       });
        //     });
        //   }
        // })
        .then(() => this.props.history.push(`/reports/batch-reports`))
        .catch((err) => {
          this.setState({ isSubmitting: false });
        });
    });
  };
  render() {
    const { departments } = this.state;
    if (this.state.loading) {
      return (
        <Backend>
          <div className="content-inner">
            <Loading />
          </div>
        </Backend>
      );
    }
    const { deptId } = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    });
    let title = '';
    if (departments.length) {
      title = departments.filter((dept) => dept.id.toString() === deptId)[0]
        .name;
    }
    return (
      <NewBatchReportPage
        {...this.state}
        title={title}
        onCreateBatch={this.onCreateBatch}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    lookup: state.lookup,
    batch: state.batch,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    lookupActions: bindActionCreators(
      Object.assign({}, lookupActions),
      dispatch,
    ),
    batchActions: bindActionCreators(Object.assign({}, batchActions), dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NewBatchReport);
